export default __webpack_public_path__ + "static/media/hi-music2.fa3b5aa5.png";